import React from "react";
import { useTranslation } from "react-i18next";
import "./about.css";
import {
  FaJava,
  FaPython,
  FaReact,
  FaNodeJs,
  FaAws,
  FaDocker,
  FaGithub,
  FaFlask as FaFlaskIcon,
} from "react-icons/fa";
import { VscVscode } from "react-icons/vsc";
import {
  SiSpring,
  SiTypescript,
  SiJavascript,
  SiHtml5,
  SiCss3,
  SiFlutter,
  SiSass,
  SiExpress,
  SiAngular,
  SiDjango,
  SiFlask,
  SiNextdotjs,
  SiCircleci,
  SiJenkins,
  SiKubernetes,
  SiPostgresql,
  SiMongodb,
  SiJunit5,
  SiNewrelic,
  SiGrafana,
  SiPostman,
  SiJira,
  SiConfluence,
  SiTerraform,
  SiMysql,
  SiRedis,
  SiElasticsearch,
  SiJest,
  SiCypress,
  SiCucumber,
  SiGit,
  SiIntellijidea,
  SiSlack,
} from "react-icons/si";
import ProfilePhoto from "assets/images/profile.png";
import Header from "components/Header";
import Footer from "components/Footer";

const About = () => {
  const { t } = useTranslation();
  const techCategories = [
    {
      title: t("about.categories.programmingLanguages"),
      items: [
        { name: "Java", icon: <FaJava /> },
        { name: "TypeScript", icon: <SiTypescript /> },
        { name: "JavaScript", icon: <SiJavascript /> },
        { name: "Python", icon: <FaPython /> },
        { name: "SCSS", icon: <SiSass /> },
        { name: "Sass", icon: <SiSass /> },
        { name: "CSS3", icon: <SiCss3 /> },
        { name: "HTML5", icon: <SiHtml5 /> },
      ],
    },
    {
      title: t("about.categories.frameworksLibraries"),
      items: [
        { name: "Spring", icon: <SiSpring /> },
        { name: "React", icon: <FaReact /> },
        { name: "Angular", icon: <SiAngular /> },
        { name: "Express", icon: <SiExpress /> },
        { name: "Django", icon: <SiDjango /> },
        { name: "Flask", icon: <SiFlask /> },
        { name: "Next.js", icon: <SiNextdotjs /> },
        { name: "Node.js", icon: <FaNodeJs /> },
        { name: "Flutter", icon: <SiFlutter /> },
      ],
    },
    {
      title: t("about.categories.cloudDevOps"),
      items: [
        { name: "AWS", icon: <FaAws /> },
        { name: "Docker", icon: <FaDocker /> },
        { name: "Kubernetes", icon: <SiKubernetes /> },
        { name: "CircleCI", icon: <SiCircleci /> },
        { name: "Jenkins", icon: <SiJenkins /> },
        { name: "Terraform", icon: <SiTerraform /> },
      ],
    },
    {
      title: t("about.categories.databasesTools"),
      items: [
        { name: "PostgreSQL", icon: <SiPostgresql /> },
        { name: "MongoDB", icon: <SiMongodb /> },
        { name: "MySQL", icon: <SiMysql /> },
        { name: "Redis", icon: <SiRedis /> },
        { name: "Elasticsearch", icon: <SiElasticsearch /> },
      ],
    },
    {
      title: t("about.categories.monitoringTesting"),
      items: [
        { name: "New Relic", icon: <SiNewrelic /> },
        { name: "Grafana", icon: <SiGrafana /> },
        { name: "JUnit", icon: <SiJunit5 /> },
        { name: "Jest", icon: <SiJest /> },
        { name: "Cypress", icon: <SiCypress /> },
        { name: "Cucumber", icon: <SiCucumber /> },
        { name: "Mockito", icon: <FaFlaskIcon /> },
      ],
    },
    {
      title: t("about.categories.developmentTools"),
      items: [
        { name: "Git", icon: <SiGit /> },
        { name: "GitHub", icon: <FaGithub /> },
        { name: "VS Code", icon: <VscVscode /> },
        { name: "IntelliJ IDEA", icon: <SiIntellijidea /> },
        { name: "Postman", icon: <SiPostman /> },
        { name: "Jira", icon: <SiJira /> },
        { name: "Confluence", icon: <SiConfluence /> },
        { name: "Slack", icon: <SiSlack /> },
      ],
    },
  ];

  return (
    <div>
      <Header />
      <div className="about-container fade-in">
        <div className="about-hero">
          <h1>{t("about.heroTitle")}</h1>
        </div>

        <div className="about-intro slide-in-left">
          <div className="about-profile-image">
            <img src={ProfilePhoto} alt="Vincent Shi - Software Engineer" />
          </div>
          <div className="about-text">
            <p dangerouslySetInnerHTML={{ __html: t("about.bio1") }} />
            <p dangerouslySetInnerHTML={{ __html: t("about.bio2") }} />
            <p>{t("about.bio3")}</p>
          </div>
        </div>

        <div className="tech-skills slide-in-right">
          <h2>{t("about.techStackTitle")}</h2>
          <div className="tech-categories">
            {techCategories.map((category, index) => (
              <div key={index} className="tech-category">
                <h3>{category.title}</h3>
                <div className="tech-grid">
                  {category.items.map((tech, techIndex) => (
                    <div key={techIndex} className="tech-item">
                      <div className="tech-icon">{tech.icon}</div>
                      <div className="tech-name">{tech.name}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
